
// jobCandidateService.ts
import axiosInstance from "./axiosConfig";
import { getUser } from "./authService";

// Job list interface
export interface JobLS {
  jobTitle: string;
  jobId: string;
  status: string;
}

// Job details interface
export interface JobDetail {
  jobTitle: string;
  jobId: string;
  AdditionalInformation: string;
  location: string;
  status: string;
  deadline: string;
  evaluationCriteria:string;
  screeningQuestions: string[];
  stats: {
    total: number;
    shortlisted: number;
    finalized: number;
    rejected: number;
  };
}

// Candidate interface
export interface Candidate {
  id: string;

  name: string;
  email: string;
  phone: string;

  status: string;
  submitted: string;

  highestEducation?: string;
  currentOrganization?: string;
  currentDesignation?: string;
  totalExperience?: string;
  relevantExperience?: string;
  keyExpertise?: string;

  currentSalary?: string;
  benefits?: string;
  expectedSalary?: string;

  answers?: string[] | string;

  criteriaScore: string;
  totalScore?: number;
  rankingJustification?: string;

  isRanked: boolean;
  cvFilePath?: string;
}
export interface CandidatesResponse {
  items: Candidate[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

// Get all jobs list for the current user's company with status filter
export const getJobsList = async (status: string): Promise<JobLS[]> => {
  try {
    const params: any = {};
    if (status) {
      params.status = status;
    }
    
    const response = await axiosInstance.get<JobLS[]>("/jobs/list", { params });
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch jobs list");
  }
};
// Get a specific job by ID
export const getJobById = async (jobId: string): Promise<JobDetail> => {
  try {
    const response = await axiosInstance.get<JobDetail>(`/jobs/${jobId}`);
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch job details");
  }
};

export const getCandidatesByJobId = async (
  jobId: string,
  page: number = 1,
  pageSize: number = 50,
  statusFilter?: string,
  searchQuery?: string
): Promise<CandidatesResponse> => {
  try {
    const response = await axiosInstance.get<CandidatesResponse>(
      `/jobs/${jobId}/candidates`,
      {
        params: {
          pageNumber: page,
          pageSize,
          statusFilter,
          searchQuery
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching candidates:", error);

    return {
      items: [],
      totalCount: 0,
      pageNumber: 1,
      pageSize: 10,
      totalPages: 0,
      hasPreviousPage: false,
      hasNextPage: false
    };
  }
};
// Update candidate status
export const updateCandidateStatus = async (candidateId: string, status: string): Promise<Candidate> => {
  try {
    const response = await axiosInstance.patch<Candidate>(`/candidates/${candidateId}`, { status });
    return response.data;
  } catch (error) {
    throw new Error("Failed to update candidate status");
  }
};
export const downloadSelectedCVs = async (
    formId: string,
    candidateIds: string[]
  ) => {

    const response = await axiosInstance.post(
      `/jobs/download-selected-cvs`,
      {
        formId,
        candidateIds
      },
      {
        responseType: "blob"
      }
    );

    return response;
  };
  export const previewCandidateCV = async (candidateId: string) => {

  const response = await axiosInstance.get(
    `/jobs/candidates/${candidateId}/cv-preview`,
    {
      responseType: "blob"
    }
  );

  return response;
};
// Download candidate CV
export const getCandidateCV = async (candidateId: string) => {
  const response = await axiosInstance.get(
    `jobs/candidates/${candidateId}/cv`,
    { responseType: 'blob' }
  );

  return response;
};